import { render, staticRenderFns } from "./FormInputs.vue?vue&type=template&id=0bd81f0a&scoped=true&"
import script from "./FormInputs.vue?vue&type=script&lang=js&"
export * from "./FormInputs.vue?vue&type=script&lang=js&"
import style0 from "./FormInputs.vue?vue&type=style&index=0&id=0bd81f0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd81f0a",
  null
  
)

export default component.exports